import axios from 'axios'
import moment from 'moment'
import { API } from '../ENV'

export const postPublicMessage = async ({ message, replyTo }) => {
  try {
    const response = await axios.post(
      `${API}/publicMessage/`,
      {
        message,
        replyTo
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const markAsQuestion = async (id) => {
  try {
    const response = await axios.post(
      `${API}/publicMessage/question/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const unmarkAsQuestion = async (id) => {
  try {
    const response = await axios.post(
      `${API}/publicMessage/remove-question/${id}`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const unmarkAllQuestions = async () => {
  try {
    const response = await axios.post(
      `${API}/publicMessage/remove-all-questions`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const sortQuestion = async ({ question, after, before }) => {
  try {
    const response = await axios.post(
      `${API}/publicMessage/sort-question`,
      { question, after, before },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    throw new Error(error.response)
  }
}

export const clearPublicMessages = async () => {
  try {
    const response = await axios.post(
      `${API}/publicMessage/mod/clear`,
      {},
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const getModPublicMessages = async ({ loadMore }) => {
  try {
    const response = await axios.get(
      `${API}/publicMessage/mod/all/${loadMore || ''}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const getPublicMessages = async ({ loadMore }) => {
  try {
    const token = localStorage.getItem('authToken')
    const response = await axios.get(
      `${API}/publicMessage/all/${loadMore || ''}`,
      {
        headers: token ? { Authorization: `Bearer ${token}` } : {}
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const getPublicMessagesSearch = async ({ loadMore, search }) => {
  const { text, startDate, endDate, limit = null } = search

  try {
    const response = await axios.get(
      `${API}/publicMessage/search/${loadMore || '*'}/${text || '*'}/${
        startDate ? moment(startDate).toISOString() : '*'
      }/${endDate ? moment(endDate).toISOString() : '*'}${limit !== null ? `/${limit}` : ''}`
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const getPublicMessageCounts = async (start, end) => {
  try {
    const response = await axios.get(
      `${API}/publicMessage/counts/${start}/${end}`
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const getPublicMessageUser = async (user) => {
  try {
    const response = await axios.get(`${API}/publicMessage/user/${user}`)
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const getQuestions = async () => {
  try {
    const response = await axios.get(`${API}/publicMessage/mod/questions`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const putPublicMessage = async ({ id, user, message }) => {
  try {
    const response = await axios.put(
      `${API}/publicMessage/`,
      {
        id,
        user,
        message
      },
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('authToken')}`
        }
      }
    )
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}

export const deletePublicMessage = async ({ id }) => {
  try {
    const response = await axios.delete(`${API}/publicMessage/${id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('authToken')}`
      }
    })
    return response
  } catch (error) {
    console.log(error.response)
    return error.response
  }
}
